// Core
import React, { useState, useRef, useEffect } from 'react';
import { Flex, Button, Box, Image, Grid, Text, Spinner, useDisclosure } from '@chakra-ui/react';
import { Route, Switch, Redirect, useRouteMatch, useHistory, useLocation } from 'react-router-dom';

// Components
import ButtonSelector from '../../components/ButtonSelector/ButtonSelector';
import Packages from './Packages';
import Settings from './Settings';
import { textLang } from 'services/Lang';

const Profile = ({
	isCheckedTypeAccount, 
	setIsCheckedTypeAccount,
	object, 
	setObject,
	findAgeFrom, setFindAgeFrom,
	findAgeTo, setFindAgeTo,
	refetchUser
}) => {
	const { path } = useRouteMatch();
	const [page, setPage] = useState(path);

	const history = useHistory();
	const handlePage = (key) => {
		history.push(key); 
		setPage(key);
	};

	return (
		<Box p="125px 15px 24px 15px" maxH="calc(100vh - 0px)">
			<ButtonSelector
	            buttons={[
	              { key: '/profile', name: textLang('Balance') },
	              { key: '/profile/settings', name: textLang('Settings') },
	            ]}
	            selected={page}
				onSelect={handlePage}
	            w={{base: '100%'}}
	            m="0 auto" />

	        <Box 
	        	position="relative"
	        	_before={{
        			content: '""',
				    position: 'absolute',
				    background: 'linear-gradient(180deg, #f1f1f1, transparent)',
				    width: '100%',
				    height: '26px',
				    top: '0',
				    left: '0'
	        	}}
	        	py="0px">
			    <Switch>
			    	<Route path="/profile/settings" render={
			    		() => <Settings 
			    			isCheckedTypeAccount={isCheckedTypeAccount} 
			    			setIsCheckedTypeAccount={setIsCheckedTypeAccount} 
			    			object={object} 
							setObject={setObject}
							findAgeFrom={findAgeFrom}
							setFindAgeFrom={setFindAgeFrom}
							findAgeTo={findAgeTo}
							setFindAgeTo={setFindAgeTo}
							refetchUser={refetchUser}
			    			/>} />
			    	<Route path="/profile"  render={() => <Packages object={object} refetchUser={refetchUser} />} />
				    <Redirect from={`${path}*`} to={`${path}`} />
				</Switch>
			</Box>
		</Box>
	);
};

export default Profile;